export type PaginationParams = {
  orderBy: string | null;
  orderDirection: 'ASC' | 'DESC' | null;
  currentPage: number;
  pageSize: number;
};

export function setPaginationParams(params: URLSearchParams, pagination: PaginationParams) {
  if (pagination.orderBy) {
    params.append('orderBy', pagination.orderBy);
  }
  if (pagination.orderDirection) {
    params.append('orderDirection', pagination.orderDirection);
  }
  params.append('limit', String(pagination.pageSize));
  params.append('offset', String((pagination.currentPage - 1) * pagination.pageSize));
}
